import palette from '../theme/palette';

const variants = [
  {
    props: { selected: true },
    style: {
      border: `1px solid ${palette.primary.main}`,
    },
  },
];

export default variants;
